export default __webpack_public_path__ + "static/media/dessert.86c8a718.png";